import { memo } from 'react';
import cn from 'classnames';
import { TPlansDetails } from 'src/types/plans.types';
import TabRow from '../TabRow';
import HeaderRow from './HeaderRow';
import ActionsRow from './ActionsRow';
import BenefitsBreakdown from './BenefitsBreakdown';
import styles from './pricing.module.scss';

type PricingTableProps = {
  radioGroupLabel?: string;
  plansInfo: TPlansDetails;
  annualSavings: string;
  billingCycle: string;
  setBillingCycle: BaseAnyFunction;
  hideSecondaryCol?: boolean;
  planButtonLabel?: string;
  containerClass?: string;
  addToCart: BaseAnyFunction;
};
const PricingTable = ({
  radioGroupLabel = 'Choose your membership',
  plansInfo,
  annualSavings,
  billingCycle,
  setBillingCycle,
  hideSecondaryCol = false,
  planButtonLabel = 'Select Membership',
  containerClass = '',
  addToCart,
}: PricingTableProps) => {
  if (!Object.keys(plansInfo!).length) return null;

  const containerStyles = cn(
    styles.container,
    {
      [styles.hideOnlineCol]: hideSecondaryCol,
    },
    containerClass,
  );

  const { smartHome, secondary } = plansInfo;

  return (
    <div className={containerStyles}>
      <TabRow secondary={secondary} smartHome={smartHome} />
      <div className={styles.tableContainer}>
        <HeaderRow
          radioGroupLabel={radioGroupLabel}
          smartHomePlan={smartHome}
          secondaryPlan={secondary}
          annualSavings={annualSavings}
          billingCycle={billingCycle}
          setBillingCycle={setBillingCycle}
        />
        <ActionsRow
          addToCart={addToCart}
          smartHomePlan={smartHome}
          secondaryPlan={secondary}
          billingCycle={billingCycle}
          planButtonLabel={planButtonLabel}
          columnClass="paddingTop-small2 paddingBottom-medium"
        />
        <BenefitsBreakdown smartHomePlan={smartHome} billingCycle={billingCycle} />
        <ActionsRow
          addToCart={addToCart}
          smartHomePlan={smartHome}
          secondaryPlan={secondary}
          billingCycle={billingCycle}
          planButtonLabel={planButtonLabel}
          columnClass="paddingTop-medium paddingBottom-medium1"
        />
      </div>
    </div>
  );
};

export default memo(PricingTable);
